export default __webpack_public_path__ + "static/media/CornReading.d50e3f1f.png";